/* eslint unused-imports/no-unused-imports: "off" */
import React, {useEffect, useRef, useState} from "react"
import {formatTextTestIds} from "@next/utils"

import {
    SingleFacetWrapper,
    CheckboxLabelWrapper,
    StyledFormControlLabel,
    FilterThumbnail,
    FacetCheckbox,
    FilterThumbnailPlaceholder,
} from "./components"
import {FacetState} from "../../../../models/FacetsState"
import SingleFacetLabel from "./singleFacetLabel"
import SingleFacetCountWrapper from "./singleFacetCountWrapper"
import {
    FEAT,
    featDeliverBy,
    HORIZONTAL_FILTERS_ITEM_COUNT_DEFAULT,
    THUMBNAIL_IMAGE_FALLBACK_PATH,
} from "../../../../config/constants"
import connect from "./connect"
import env from "../../../../config/env"

export interface FacetListProps {
    filterName: string
    facet: FacetState
    handleSetFacet: (facetValue: string, filterName: string) => void
    showCount?: boolean
    shouldGetFocus: boolean
    imagePath?: string | null
    filterItemsCount?: number
    thumbnailSize?: string | null
}

const getTestIdForElement = (facetName: string, elementName: string, filterName: string) =>
    formatTextTestIds(`plp-facet-${elementName}-${filterName}-${facetName}`)

export const SingleFacet = ({
    filterName,
    facet,
    handleSetFacet,
    showCount,
    shouldGetFocus,
    imagePath,
    filterItemsCount,
    thumbnailSize,
}: FacetListProps) => {
    const refCheckbox = useRef<HTMLDivElement>(null)
    const isFeatFacet = filterName === FEAT

    const [imageLoaded, setImageLoaded] = useState<boolean>(false)

    const imageOnErrorHandler = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.onerror = null
        e.currentTarget.src = `${env.REACT_APP_CDN_BASEURL}${THUMBNAIL_IMAGE_FALLBACK_PATH}`
    }

    useEffect(() => {
        if (refCheckbox.current && shouldGetFocus) refCheckbox.current.focus()
    }, [])

    const handleKeyDown = e => {
        if (e.key === "Enter") {
            handleSetFacet(facet.v, filterName)
        }
    }

    return (
        <SingleFacetWrapper key={facet.n} data-testid={`horizontal-filter-facet-${facet.n}`}>
            <StyledFormControlLabel
                ref={refCheckbox}
                tabIndex={0}
                onKeyDown={handleKeyDown}
                control={
                    <>
                        <FacetCheckbox
                            onChange={() => handleSetFacet(facet.v, filterName)}
                            checked={facet.s || false}
                            color="primary"
                            tabIndex={-1}
                            $filterName={filterName}
                            disabled={facet.d}
                            $hasThumbnail={typeof imagePath === "string"}
                            $filterItemsCount={filterItemsCount || HORIZONTAL_FILTERS_ITEM_COUNT_DEFAULT}
                        />
                        {imagePath && (
                            <>
                                <FilterThumbnail
                                    src={imagePath}
                                    alt={`${facet.v}-thumbnail`}
                                    thumbnailSize={thumbnailSize}
                                    data-testid={`plp-hf-search-category-thumbnail-${filterName}-${facet.v}`}
                                    onLoad={() => setImageLoaded(true)}
                                    imageLoaded={imageLoaded}
                                    onError={imageOnErrorHandler}
                                />
                                <FilterThumbnailPlaceholder
                                    key={facet.v}
                                    variant="circular"
                                    thumbnailSize={thumbnailSize}
                                    imageLoaded={imageLoaded}
                                />
                            </>
                        )}
                    </>
                }
                label={
                    <CheckboxLabelWrapper isFeatFacet={isFeatFacet}>
                        <SingleFacetLabel facet={facet} />
                        {showCount && facet.v !== featDeliverBy && (
                            <SingleFacetCountWrapper
                                childtestid={getTestIdForElement(facet.v, "count-label", filterName)}
                                facet={facet}
                            />
                        )}
                    </CheckboxLabelWrapper>
                }
                data-testid={getTestIdForElement(facet.v, "checkbox", filterName)}
            />
        </SingleFacetWrapper>
    )
}

export default connect(SingleFacet)
